import { Nullable } from 'src/core/common/domain/types/types';

export type CreateAttendancePunchPayload = {
  scannedNfcCode: Nullable<string>;
};

export abstract class AttendanceRepository {
  abstract createPunch(punch: CreateAttendancePunchPayload): Promise<void>;
}
